export default __webpack_public_path__ + "static/media/eoaf_white.1312601f.svg";